import Components from "./components";
import Dialog from "./dialog";
import Pipes from "./pipes";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.reports`;

    return angular.module(moduleName, [Components(moduleName), Dialog(moduleName), Pipes(moduleName)])
                  .name;
}
